import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Collapse from '@material-ui/core/Collapse';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

// import CONSTANTS from '../utils/Constants';

const styles = theme => ({
	container: {
		marginTop: theme.spacing.unit
	},
	group: {
		marginLeft: (2 * theme.spacing.unit)
	}
});

class ConditionalSentiment extends Component {
	render() {
		let {classes, visible, values, selection, changeHandler} = this.props;
		
		if(visible) {
			/*<Typography variant="subtitle1">How do you feel?</Typography>*/

			return (
				<FormControl className={classes.container} component="fieldset">
					{/* TODO - drop down for desktop */}
					<Typography variant="subtitle1">How do you feel?</Typography>
					<Collapse in={values.length > 3} collapsedHeight="146px">
						<RadioGroup
							aria-label="How do you feel?"
							name="sentiment"
							value={selection}
							className={classes.group}
							onChange={changeHandler}
						>
							{values.map(value => {
								let lcValue = value.toLowerCase()
								let cpValue = lcValue.slice(0, 1).toUpperCase() + lcValue.slice(1);
								return (
									<FormControlLabel value={lcValue} key={lcValue} control={<Radio aria-label={cpValue} />} label={cpValue} />
								);
							})}
						</RadioGroup>
					</Collapse>
				</FormControl>
			);
		
		} else {
			return null;
		}
	}
}

ConditionalSentiment.propTypes = {
	classes: PropTypes.object.isRequired,
	visible: PropTypes.bool,
	selection: PropTypes.string,
	values: PropTypes.array.isRequired,
	changeHandler: PropTypes.func.isRequired
};

export default withStyles(styles)(ConditionalSentiment);
